(() => {
  const header = document.getElementById('site-header');
  if (!header) return;
  if (header.dataset.autoNavTextSwitch !== 'true') return;

  const navDark  = header.dataset.navTextDark;  // dark text bg light
  const navLight = header.dataset.navTextLight; // light text bg dark

  function parseColorToRGB(color) {
    const el = document.createElement('div');
    el.style.color = color;
    document.body.appendChild(el);
    const rgb = getComputedStyle(el).color;
    document.body.removeChild(el);
    const m = rgb.match(/\d+/g);
    return m ? [parseInt(m[0], 10), parseInt(m[1], 10), parseInt(m[2], 10)] : [0, 0, 0];
  }

  function luminance([r, g, b]) {
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function getHeaderTextColor() {
    return (
      getComputedStyle(header).getPropertyValue('--color-text-header').trim() ||
      getComputedStyle(header).getPropertyValue('--color-text-header-absolute').trim() ||
      getComputedStyle(header).color ||
      '#000'
    );
  }

  function applyNavText() {
    const textLum = luminance(parseColorToRGB(getHeaderTextColor()));
    const isLightText = textLum > 0.6;

    // If theme decided light text, respect it
    const chosen = isLightText ? (navLight || '#fff') : (navDark || '#111');

    header.style.setProperty('--header-nav-text-color', chosen);
  }

  let ticking = false;
  const onUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      applyNavText();
      ticking = false;
    });
  };

  const mo = new MutationObserver(onUpdate);
  mo.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });

  applyNavText();
  window.addEventListener('scroll', onUpdate, { passive: true });
  window.addEventListener('resize', onUpdate);
  setTimeout(applyNavText, 50);
})();
